import { useQuery } from '@tanstack/react-query'
import { throwIfApiError } from 'utils/error-handling/throwifApiError'
import { useRfxHttpClient } from '@omnea-app/fe-rfx/useRfxHttpClient'

const getMyActiveRfxsQueryKey = 'myRfxsQueryKey'

export const useGetMyActiveRfxs = () => {
  const rfxHttpClient = useRfxHttpClient()

  return useQuery({
    queryKey: [getMyActiveRfxsQueryKey],
    queryFn: async () => {
      const { data, error } = await rfxHttpClient.GET('/')
      throwIfApiError(error)
      return data
    },
  })
}
